<div
  class="recipients-control form-control"
  [class.is-valid]="valid"
  [class.is-invalid]="invalid"
  (click)="focusInput()"
>
  @for (chip of chips; track chip.email) {
    <span class="recipient-chip" [class.recipient-chip-invalid]="!chip.valid" [title]="chip.email">
      {{ chip.name }}
      <button
        type="button"
        class="recipient-chip-remove"
        i18n-aria-label
        aria-label="Remove recipient"
        (click)="remove(chip); $event.stopPropagation()"
      >
        &times;
      </button>
    </span>
  }

  <input
    #recipientInput
    type="text"
    class="recipients-input"
    [formlyAttributes]="field"
    [(ngModel)]="pending"
    [ngModelOptions]="{ standalone: true }"
    (keydown)="onKeydown($event)"
    (blur)="onBlur()"
  />

  @if (props.actions?.length) {
    <span class="recipients-actions" (click)="$event.stopPropagation()">
      @for (action of props.actions; track action.text) {
        <button type="button" class="btn btn-link btn-sm p-0 ms-2" (click)="action.onClick()">
          {{ action.text }}
        </button>
      }
    </span>
  }
</div>
